export const DEFAULT_REGION_ID = '672';
